import { connect } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';
import { CommissionStatusType } from '@wix/da-shared-react/pkg/types/commissions';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../selectors/modules';
import { ModuleType } from '../../../../../types/modules';
import { changeAllCommissionsStatus } from '../../../../actions/commissions';
import { openCommissionEditModal } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';

const mapStateToProps = state => {
  const { isOpenForCommissions } = getModuleDataByModuleType(
    state,
    ModuleType.COMMISSIONS
  );
  const streamId = getShopItemsStreamId(ShopItemType.COMMISSIONS);
  return {
    streamId,
    isOpenForCommissions,
    commissions: getDeviationsByIds(
      state,
      streamSelectors.getItems(state, streamId)
    ),
    total: streamSelectors.getTotal(state, streamId),
    hasMore: streamSelectors.hasMore(state, streamId),
    isFetching: streamSelectors.isFetching(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
    username: getProfileOwnerUser(state).username,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMore: () =>
      dispatch(
        withOffset.actions.fetch(getShopItemsStreamId(ShopItemType.COMMISSIONS))
      ),
    openCommissionEditModal: () =>
      dispatch(openCommissionEditModal({ deviationId: undefined })),
    changeAllCommissionsStatus: (status: CommissionStatusType) =>
      dispatch(changeAllCommissionsStatus({ status })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
